export interface ITestimonial {
    testimonial: string;
    credit: string;
}

export const testimonials: ITestimonial[] = [
    {
        testimonial: "Raquel is an impressive and talented stylist. She has an intuitive ability with color and highlights. I always walk away with an amazing style that I can handle with ease. Best professional salon!",
        credit: "Hope R"
    },
    {
        testimonial: "Raquel has been my hair stylist for more than 15 years. I’ve had long hair cuts, short hair cuts and everything in between. I’ve had highlights and color. Expectations are always discussed and I have never been disappointed. Nor have the friends and family I have referred. Each and every cut/process is done with extraordinary skill and attention to detail. I would follow her to the salon at the end of the earth if necessary.",
        credit: "Cindy J"
    },
    {
        testimonial: "Katie has been highlighting my hair for the last 4+ years and is truly a master of blonde color! I started carrying around her business cards because I would constantly be asked “who does your color?!” In addition to amazing results, Katie is a fantastic person to chat and have some fun with while sitting for the appointment. She is a true asset to the R&Co team!",
        credit: "Sarah W"
    },
    {
        testimonial: "Katie made me feel comfortable and relaxed. I’ve gotten my haircut by her twice now and will continue to come back! She’s a great listener and is always ready to give me the look I want to feel the most confident. I recommend anyone go to her. Very satisfied!",
        credit: "Tiffany M"
    },
    {
        testimonial: "I cannot recommend Aimee ENOUGH. I have had so many people come up to me and ask who I go to for my hair for years and I will never go to anyone else. I've truly never trusted someone so much with my hair! I literally would let her do whatever she wants and I know I'll always be in good hands. If you want PERFECTION go to my girl Aimee!",
        credit: "Jordan N"
    },
    {
        testimonial: "Cannot praise Raquel at Raquel & Company Hair Salon enough for always taking my wildest hair dreams and making them a realitv that's tailored to me. I'm loving the blended contrast between my natural dark roots and the wheat blonde at the ends, effectively giving me both brunette and blonde!",
        credit: "Ashley M"
    },
    {
        testimonial: "Would just like to mention that Kendra has been doing my hair for many years and and I have always been more than pleased.  She listens, she cares and takes great pride in her work -- as well she should!!  I receive many compliments on my hair and that's because of her ability to cut and style it beautifully!!",
        credit: "Arline C"
    }
];